module.exports = __webpack_public_path__ + "img/3-1.33a44cc2.jpg";